import React from 'react';
import { generateFormattedDate } from './assets/generateFormattedDate';
import { Badge } from 'reactstrap';
import {
  Image,
  ImageContent,
  MessageContent,
  MessageText,
  UserName,
  UserTimestamp
} from './components/styled';
import './style.css';

import { AdminContent } from './components/styledUser';
import { isSourceExpired } from './utils';

const SpyMessage = ({
  message = '',
  title = '',
  time = '',
  name = '',
  type = 'text',
  options = '',
  source = ''
}) => {
  const isExpired = isSourceExpired(source, time);

  if (isExpired !== undefined && isExpired) {
    type = 'text';
    message = 'Link expirado com mais de 7 dias.';
    source = '';
  }

  return (
    <AdminContent>
      <UserName>{name}:</UserName>
      <MessageContent>
        <MessageText>
          {title ||
            (message &&
              (type === 'link' ? (
                <u onClick={() => window.open(message, '_blank')}>{message}</u>
              ) : (
                message
              ))) ||
            options}
          {type === 'file' && (
            <u
              className="g4-link"
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(source, '_blank')}
            >
              {source}
            </u>
          )}
        </MessageText>
        {options && (
          <Badge
            className="user-option"
            color="light"
            title={`Opção da ${name}`}
          >
            Opção
          </Badge>
        )}
        {type === 'image' && (
          <ImageContent>
            <Image
              src={source}
              alt={`imagem de ${name}`}
              onClick={() => window.open(source, '_blank')}
            />
          </ImageContent>
        )}
      </MessageContent>

      <UserTimestamp>{time && generateFormattedDate(time)}</UserTimestamp>
    </AdminContent>
  );
};

export default SpyMessage;
